import(/* webpackMode: "eager" */ "/vercel/path0/app/docs/page.tsx");
